import { useEffect, useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import { ALX_AFRICA_DOMAIN, ALX_AFRICA_STAGING_DOMAIN } from '../constants';
import { useCognito } from '../providers/cognito';

export const useAuthRedirect = () => {
  const [searchParams] = useSearchParams();
  const { currentUser } = useCognito();

  const redirectUriString = useMemo(
    () =>
      searchParams.get('redirect_uri') ||
      sessionStorage.getItem('redirect_uri'),
    [searchParams]
  );

  useEffect(() => {
    if (
      redirectUriString &&
      (redirectUriString.includes(ALX_AFRICA_DOMAIN) ||
        redirectUriString.includes(ALX_AFRICA_STAGING_DOMAIN))
    ) {
      if (currentUser) {
        sessionStorage.removeItem('redirect_uri');
        console.log('moving to ', redirectUriString);
        window.location.replace(redirectUriString);
      } else {
        sessionStorage.setItem('redirect_uri', redirectUriString);
      }
    }
  }, [currentUser, redirectUriString]);
};
